import(/* webpackMode: "eager", webpackExports: ["IntegrationsGrid"] */ "/tmp/8de65608d263eb6/components/sections/IntegrationsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de65608d263eb6/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65608d263eb6/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65608d263eb6/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de65608d263eb6/node_modules/next/dist/client/link.js");
